var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanvas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20027_19063",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.238281,
    y: 0.5,
    width: 18,
    height: 19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20027_19063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.238281 9V1H8.23828V9H0.238281ZM0.238281 19V11H8.23828V19H0.238281ZM10.2383 9V1H18.2383V9H10.2383ZM10.2383 19V11H18.2383V19H10.2383ZM2.23828 7H6.23828V3H2.23828V7ZM12.2383 7H16.2383V3H12.2383V7ZM12.2383 17H16.2383V13H12.2383V17ZM2.23828 17H6.23828V13H2.23828V17Z",
    fill: "#000032"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvas);
export default __webpack_public_path__ + "static/media/Canvas.8dfc9ea5a8eb87ca0961f29d026d39bd.svg";
export { ForwardRef as ReactComponent };